import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useSpace } from "@/context/SpaceContext";
import { AppIcon } from "@/components/apps/AppIcon";
import { IconBadge } from "@/components/admin/IconBadge";
import { vLabel } from "@/lib/version";
import { CategoryBadge, CategoryToggle } from "@/components/admin/CategoryToggle";
import { PlatformBadge } from "@/components/apps/Platform";
import { ReviewBadge } from "@/components/admin/ReviewPanel";
import { IncompleteAlert } from "@/components/dev/IncompleteAlert";

export const AdminAppRow = ({ app, onChanged }) => {
  const { t, fmtBytes, fmtDownloads } = useI18n();
  const { root } = useSpace();
  const v = app.active_version;
  return (
    <li className="card-carbon hoverable flex flex-col flex-wrap gap-4 rounded-2xl p-4 sm:flex-row sm:items-center" data-testid={`admin-app-row-${app.id}`}>
      {app.platform?.incomplete && <div className="w-full min-w-0"><IncompleteAlert to={`${root}/apps/${app.id}?completer=1`} testId={`app-row-incomplete-${app.id}`} /></div>}
      <div className="flex min-w-0 max-w-full flex-1 items-center gap-4">
        <AppIcon app={app} size="h-14 w-14" px={56} />
        <div className="min-w-0 flex-1">
          <p className="break-words [overflow-wrap:anywhere] font-display text-sm font-bold uppercase tracking-wide text-white" data-testid="admin-app-name">{app.name}</p>
          {app.review === "pending" && <ReviewBadge status="pending" testId={`admin-app-review-${app.id}`} />}
          {app.package && <p className="truncate text-[0.7rem] text-neutral-500" data-testid="admin-app-package">{app.package}</p>}
          <p className="mt-1 text-xs text-neutral-400" data-testid="admin-app-active-version">
            {v ? t("admin.activeLine", { v: vLabel(v), size: fmtBytes(v.size) }) : t("apps.noVersion")}
            {" · "}
            {t("admin.stored", { n: app.versions_count })}
          </p>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-[var(--gold-bright)]" data-testid={`admin-app-downloads-${app.id}`}>{fmtDownloads(app.downloads)}</span>
            {app.icon_url && <IconBadge app={app} />}
            <CategoryBadge app={app} />
            <PlatformBadge app={app} testId={`admin-app-platform-${app.id}`} />
          </div>
        </div>
      </div>
      <div className="flex min-w-0 flex-wrap gap-2 self-start sm:self-auto">
        <CategoryToggle app={app} onChanged={onChanged} />
        <Link to={`${root}/apps/${app.id}`} className="btn-gold btn-sm" data-testid={`admin-manage-app-${app.id}`}>
          <Settings2 className="h-4 w-4" /> {t("admin.manage")}
        </Link>
      </div>
    </li>
  );
};
